var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-field",
      class: {
        "input-field--readonly": this.readonly,
        "input-field--disabled": this.disabled,
        "input-field--vertical": this.vertical,
        "input-field--stretch": this.stretch
      }
    },
    [
      _vm.inputOut
        ? _c(
            "textarea",
            _vm._g(
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.modelValue,
                      expression: "modelValue"
                    },
                    { name: "autosize", rawName: "v-autosize" }
                  ],
                  attrs: {
                    id: _vm.id,
                    placeholder: _vm.placeholder,
                    readonly: _vm.readonly,
                    disabled: _vm.disabled
                  },
                  domProps: { value: _vm.modelValue },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.modelValue = $event.target.value
                    }
                  }
                },
                "textarea",
                _vm.$attrs,
                false
              ),
              _vm.inputListeners
            )
          )
        : _c(
            "textarea",
            _vm._g(
              _vm._b(
                {
                  directives: [{ name: "autosize", rawName: "v-autosize" }],
                  attrs: {
                    id: _vm.id,
                    placeholder: _vm.placeholder,
                    readonly: _vm.readonly,
                    disabled: _vm.disabled
                  },
                  domProps: { value: _vm.value }
                },
                "textarea",
                _vm.$attrs,
                false
              ),
              _vm.inputListeners
            )
          ),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "input-field__label-textarea",
          class: {
            "input-field__label-textarea--active":
              _vm.labelActive && this.vertical
          },
          attrs: { for: _vm.id }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm._t("helper")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-009a9fe6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-009a9fe6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/TextareaField.vue
// module id = 252
// module chunks = 0